module.exports = __webpack_public_path__ + "static/img/15.e3d68f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/7/15.png
// module id = DZFm
// module chunks = 0